export enum DateFormat {
  full = 'YYYY-MM-DD',
  pretty = 'MMM Y',
  small = 'YYYY',
}

export enum LuxonDateFormat {
  full = 'yyyy-MM-dd',
  pretty = 'MMM y',
  small = 'yyyy',
}

export enum ExtremeDateValue {
  max = '9999-12-31',
  min = '0000-01-01',
}

export const formatDateByLength = (length: number): LuxonDateFormat => {
  if (length === 1) {
    return LuxonDateFormat.small;
  }

  if (length === 2) {
    return LuxonDateFormat.pretty;
  }

  return LuxonDateFormat.full;
};

export const getCorrectDateFormat = (date: string): LuxonDateFormat => formatDateByLength(date.split('-').length);
